import { mapGetters, mapActions } from "vuex"
import { dynamicParameter } from '../service/mixin-service';

const identity = (value) => value;

export default function staticData(name, path, getData = identity, params = { page: 'unpaged', sort: 'viewOrder' }) {
  // ONLY use for REGISTRY and BASEDATA!

  const getPath = dynamicParameter(path);
  const getParams = dynamicParameter(params);

  const restConfig = self => ({ url: '/rest/v4/' + getPath(self), params: getParams(self) });

  return {
    computed: {
      ...mapGetters('configuration', ['getConfiguration']),
      [name]: {
        get() {
          const cache = this.getConfiguration(restConfig(this));
          if (!cache) {
            this.loadConfiguration(restConfig(this));
            return [];
          }
          else return getData(cache);
        }
      }

    },
    methods: {
      ...mapActions('configuration', ['loadConfiguration', 'loadConfigurationWithSamePath']),
      [`reload_${name}`]() {
        this.loadConfiguration(restConfig(this))
      },
      [`reloadWithSamePath_${name}`]() {
        this.loadConfigurationWithSamePath(restConfig(this));
      }
    },
    created() {
      const cache = this.getConfiguration(restConfig(this));
      if (!cache) {
        this.loadConfiguration(restConfig(this));
      }
    }
  }
}
